"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ThemeContext = _interopRequireDefault(require("./ThemeContext"));

var _cssVariables = require("./cssVariables");

var _defaultThemeColors = _interopRequireDefault(require("./defaultThemeColors"));

var _constant = require("./constant");

require("../Styles/index.css");

var _dark = _interopRequireDefault(require("./enho_1/dark.theme"));

var _light = _interopRequireDefault(require("./enho_1/light.theme"));

var _excluded = ["theme", "mode", "themeConfig"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var deepMergeObject = function deepMergeObject() {
  var targetObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var sourceObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // clone the source and target objects to avoid the mutation
  var copyTargetObject = JSON.parse(JSON.stringify(targetObject));
  var copySourceObject = JSON.parse(JSON.stringify(sourceObject)); // Iterating through all the keys of source object

  Object.keys(copySourceObject).forEach(key => {
    if (typeof copySourceObject[key] === 'object') {
      // If property has nested object, call the function recursively
      copyTargetObject[key] = deepMergeObject(copyTargetObject[key], copySourceObject[key]);
    } else {
      // else merge the object source to target
      copyTargetObject[key] = copySourceObject[key];
    }
  });
  return copyTargetObject;
};

var themeConfigEnho1 = {
  light: _light.default,
  dark: _dark.default
};

function ThemeProvider(_ref) {
  var {
    theme,
    mode,
    themeConfig
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var [currentTheme, setCurrentTheme] = (0, _react.useState)(mode);
  var currentColors = (0, _react.useMemo)(() => {
    // eslint-disable-next-line no-underscore-dangle
    var _colors = _defaultThemeColors.default;

    if (theme === _constant.THEME.ENLIGHTEN && !themeConfig.dark && !themeConfig.light && typeof themeConfig === 'object') {
      _colors = deepMergeObject(_defaultThemeColors.default, themeConfig);
    }

    if (theme === _constant.THEME.ENHO_1) {
      _colors = themeConfigEnho1[currentTheme];
    }

    if (theme === _constant.THEME.ENHO_1 && themeConfig[currentTheme]) {
      _colors = deepMergeObject(themeConfigEnho1[currentTheme], themeConfig[currentTheme]);
    }

    return _colors;
  }, [theme, currentTheme, themeConfig]);
  var defaultValues = (0, _react.useMemo)(() => ({
    currentTheme,
    colors: currentColors,
    setScheme: scheme => {
      setCurrentTheme(scheme);
    }
  }), [currentTheme, currentColors]); // useEffect(() => {
  //   if(!themeConfig[currentTheme]) {
  //     throw new Error(`NOT FOUND: colors for ${currentTheme} is not available in props.themeConfig`)
  //   }
  // },[currentTheme]);

  (0, _react.useEffect)(() => {
    (0, _cssVariables.registerTheme)(defaultValues.colors);
  }, [defaultValues.colors]);
  (0, _react.useEffect)(() => {
    setCurrentTheme(mode);
  }, [mode]);
  return /*#__PURE__*/_react.default.createElement(_ThemeContext.default.Provider, {
    value: defaultValues
  }, props.children);
}

ThemeProvider.propTypes = {
  mode: _propTypes.default.oneOf([_constant.MODE.LIGHT, _constant.MODE.DARK]),
  theme: _propTypes.default.oneOf([_constant.THEME.ENHO_1, _constant.THEME.ENLIGHTEN]),
  themeConfig: _propTypes.default.exact({
    [_constant.MODE.LIGHT]: _propTypes.default.shape({}),
    [_constant.MODE.DARK]: _propTypes.default.shape({}),
    [_constant.MODE.CUSTOM]: _propTypes.default.shape({})
  }),
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired
};
ThemeProvider.defaultProps = {
  mode: _constant.MODE.LIGHT,
  themeConfig: {},
  theme: _constant.THEME.ENLIGHTEN
};
var _default = ThemeProvider;
exports.default = _default;